export default "__VITE_ASSET__CtuIpCbW__"